// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// find all testimonials
const banners = document.querySelectorAll('.sm-hero-banner');

// loop through each testimonial
banners.forEach((banner) => {
	// find the swiper container
	const container = banner.querySelector('.swiper');
	const $parent = jQuery(container).find(".swiper-wrapper");
	const $children = $parent.children();

	function shuffle(array) {
		let currentIndex = array.length;

		// While there remain elements to shuffle...
		while (currentIndex !== 0) {

			// Pick a remaining element...
			let randomIndex = Math.floor(Math.random() * currentIndex);
			currentIndex--;

			// And swap it with the current element.
			[array[currentIndex], array[randomIndex]] = [
				array[randomIndex], array[currentIndex]];
		}

		return array;
	}

	$parent.empty().append(shuffle($children));

	// init Swiper:
	const swiper = new Swiper(container, {
		// Optional parameters
		direction: 'horizontal',
		loop: true,
		autoHeight: true,

		// disable interactivity
		allowTouchMove: false,

		// If we need pagination
		pagination: {
			el: '.swiper-pagination',
			clickable: true
		},

		// Navigation arrows
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},

		// And if we need scrollbar
		scrollbar: {
			el: '.swiper-scrollbar',
		}
	});

	// write a function that updates the pagination after the gallery has been initialized
	const updatePagination = () => {
		const pagination = container.querySelector('.swiper-pagination');
		const paginationNumbered = container.querySelector('.swiper-numbered-pagination');
		const paginationCurrentNumber = paginationNumbered.querySelector('.pagination-index--current');
		const paginationTotalNumber = paginationNumbered.querySelector('.pagination-index--total');
		const slides = container.querySelectorAll('.swiper-slide');
		let bulletCount = container.getAttribute('data-bullet-limit');

		if(slides.length >= bulletCount) {
			paginationNumbered.style.display = 'flex';
			pagination.style.display = 'none';
		} else if(slides.length > 1) {
			pagination.style.display = 'flex';
			paginationNumbered.style.display = 'none';
		} else {
			pagination.style.display = 'none';
			paginationNumbered.style.display = 'flex';
		}

		paginationTotalNumber.textContent = slides.length;

		slides.forEach((slide, index) => {
			if (slide.classList.contains('swiper-slide-active')) {
				paginationCurrentNumber.textContent = index + 1;
			}
		});
	}

	// call the function to update the pagination
	updatePagination();

	// listen for the slide change event and update the pagination accordingly
	swiper.on('transitionEnd', () => {
		updatePagination();
	});
})
